import styled, { css } from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  width: ${(props) => {
    return props.width ? props.width : '100%';
  }};
  display: flex;
  flex-direction: ${({ layout }) => {
    return layout === 'horizontal' ? 'row' : 'column';
  }};
  justify-content: space-between;
  gap: 10px;

  ${(props) => {
    const count = props.columnNum;
    return (
      props.columnNum &&
      css`
        display: grid;
        grid-template-columns: repeat(${count}, 1fr);
      `
    );
  }}
`;

export default Wrapper;

export const Menu = styled.div`
  width: 100%;
  padding: ${(props) => {
    return props.radioPadding ? props.radioPadding : '20px 18px';
  }};
  color: ${color.black2};
  font-size: 16px;
  font-weight: 600;
  display: ${(props) => {
    return props.block ? 'block' : 'inline-flex';
  }};
  cursor: pointer;
  border-radius: 12px;
  border: 1px solid ${color.grey1};
  &.selected {
    border: 1px solid ${color.orange1};
  }
  .custom_radio {
    width: 14px;
    min-width: 14px;
    height: 14px;
    min-height: 14px;
    border-radius: 100px;
    border: 1px solid ${color.grey1};
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
  }

  .component_description {
    margin-top: 8px;
    max-width: ${(props) => {
      return props.fullWidth ? 'unset' : '267px';
    }};
  }

  .component_radio_group_text_label {
    white-space: nowrap;
  }

  .anticon {
    font-size: 18px;
    color: ${color.black2};
    margin-right: 8px;
  }

  .anticon.selected_radio {
    font-size: 14px;
    margin-right: 8px;
  }
`;
